import { capitalize } from "lodash";

export const QUESTIONS = [
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `I joined Future because I wanted to improve my ${adjective1} ${bodypart}. I got to work with ${coworker} and they specialize in exercising with a ${noun1}, which is a ${adjective2} experience. Supposedly, it specifically targets the ${bodypart}. Coach ${coworker} inspired me to train so hard that my relatives are starting to say I resemble that of a large ${animal}. I always wanted to be a ${animal} 🥺 `;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `Future is a splendid service. I really liked the fact that my coach ${coworker} is ${adjective1}. Coach ${coworker} gives me this unique exercise called ${animal} crawls. As you'd imagine, I act like a ${animal}, and just well… crawl, sometimes while holding a ${noun1} on my back for resistance. People at the gym give me weird looks but they're just jealous of my ${adjective2} ${bodypart} that Future has grown 😎`;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `When my friends ask me what Future is, I have nothing but ${adjective1} things to say. Coach ${coworker} gives me unlimited personal training sessions for the price of a ${noun1}. They've helped me grow my ${bodypart} to the size of a ${animal} ${bodypart}. ${capitalize(
      adjective2
    )}. App. Period.`;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `Three words: Future, gainz, me. My ${adjective1} ${bodypart} has gotten a little less ${adjective1} and a little more ${adjective2} thanks to ${coworker} who has me working out 5x a week with a ${noun1}. I've become obsessed with fitness, almost as much as I'm obsessed with ${animal}s. When my parents say grab a plate for dinner, I get confused and grab a 45 lbs plate which I suppose is a good thing 🤷`;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `Typically I make excuses to workout because I feel the need to take care of my ${animal}. And when I do workout, I tend to focus only on exercising my ${adjective1} ${bodypart}. With Future, I can get a ${adjective2} workout in anytime and anywhere. If I don't have equipment, my coach ${coworker} has me exercise with a ${noun1} meaning I never have to miss a lift anymore 💪`;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `I sold my life-long pet ${animal} and my favorite ${noun1} to afford Future, but it was well worth it. I'm a week in and I can tell my ${adjective1} mother is already noticing results. My favorite workout of the week from coach ${coworker} is the 20 minute ${adjective2} ${bodypart} blaster 🔥`;
  },
  ({ coworker, adjective1, adjective2, noun1, animal, bodypart }) => {
    return `LOVE. FUTURE. Aside from ${adjective2} workouts, I learned this ${adjective1} protein shake recipe from coach ${coworker}. It's 100g of crushed ${noun1}, a sprinkle of ${animal} hair, mixed with warm water. Needless to say, the ${bodypart} gains have been unreal and I'm ready for summer 🌞`;
  },
];

export const createReviewObject = (inputs, forceQuestionIndex) => {
  const isDebugging = forceQuestionIndex !== undefined;

  const questionIndex = Math.floor(Math.random() * QUESTIONS.length);

  const test = {
    name: "David Dunkovich",
    coworker: "Eddie Borstein",
    adjective1: "silly",
    adjective2: "hairy",
    noun1: "pencil",
    animal: "giraffe",
    bodypart: "toe",
  };

  return {
    name: isDebugging ? test.name : inputs.name,
    text: QUESTIONS[isDebugging ? forceQuestionIndex : questionIndex](
      isDebugging ? test : inputs
    ),
    stars: Math.ceil(Math.random() * 5),
    createdAt: new Date(),
  };
};
